var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.041 9.01482C10.9375 9.02258 10.4031 9.05447 9.2108 9.05447C8.26251 9.05447 7.58923 9.02603 7.35302 9.01482C3.68832 8.85361 0.952945 8.21567 0.952945 7.45187C0.952945 6.68807 3.68832 6.05099 7.35302 5.8872V8.37947C7.59268 8.39671 8.27889 8.43723 9.22718 8.43723C10.3651 8.43723 10.935 8.38981 11.0375 8.38033V5.88892C14.6945 6.05185 17.4238 6.68979 17.4238 7.45187C17.4238 8.21395 14.6953 8.85189 11.0375 9.01396L11.041 9.01482ZM11.041 5.63116V3.40096H16.1445V6.10352e-05H2.24951V3.40096H7.35216V5.6303C3.20469 5.82082 0.0856934 6.64238 0.0856934 7.62687C0.0856934 8.61137 3.20469 9.43207 7.35216 9.62345V16.7701H11.0401V9.62086C15.1781 9.43034 18.2919 8.60964 18.2919 7.62601C18.2919 6.64238 15.1807 5.82168 11.0401 5.6303L11.041 5.63116Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.c633c84b53a98e8ac15d6449b06c3897.svg";
export { ForwardRef as ReactComponent };